import { Button, IButtonProps, Size, Theme } from '@busybusy/webapp-react-ui';
import { CloseIcon } from 'assets/icons';
import classNames from 'classnames';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { isNil } from 'lodash';
import { ClassName } from 'types/ClassName';
import './Capsule.scss';

export interface ICapsuleProps extends IButtonProps {
  className?: ClassName;
  title: string;
  onClick?: (event: React.MouseEvent) => void;
  onClose?: () => void;
}

export default function Capsule({
  className,
  title,
  size = Size.SMALL,
  type = 'secondary',
  onClose,
  onClick,
  ...buttonProps
}: ICapsuleProps) {
  const classes = classNames('capsule', { selectable: !isNil(onClick), closable: !isNil(onClose) }, className);

  return (
    <div className={classes}>
      <Button className="capsule-button" onClick={onClick} rounded={true} size={size} type={type} {...buttonProps}>
        <div className="capsule-title-button">{title}</div>
      </Button>
      {onClose && (
        <IconButton
          className="close-button"
          theme={type === 'secondary' ? Theme.LIGHT : Theme.DARK}
          svg={CloseIcon}
          onClick={onClose}
          size="xs"
          buttonSize={Size.SMALL}
          ripple={false}
        />
      )}
    </div>
  );
}
